<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7VTpwJ/cover.jpg?1701477406125" alt="This image is the cover for the book Secret Weapons, Castle Court Kids"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secret Weapons, Castle Court Kids
      </h1>
      <p class="bookDescription body article font2">
        <b>The Castle Court Kids are back—and this time, they’re teaming up to fight the bad guys</b><br/>Kate Nicely and her BFF, Aurora Pappas, haven’t told anyone about their top-secret science project that’s going to win first place at the Annual Interschool Science Fair. Carlos Garcia, Bucky Brockhurst, and Eddy Wong are working on one, too, if they could just agree on an idea that isn’t lame. But everyone could lose to Aurora’s kid brother, Carson, and Eddy’s younger brother, Web, who everyone at school knows is a genius. Does Web’s secret project have something to do with the two sinister-looking men in a black van who’ve been lurking around Castle Court? The rumors spread like wildfire: Web is developing some kind of secret weapon and terrorists are trying to steal it. That’s when the Castle Court Kids decide to form the top-secret AT Club (that’s Anti-Terrorist, of course). With the kids—and one enormous Saint Bernard—outnumbering the bad guys, all they have to do is wait for the perfect time to strike.<br/>This ebook features an extended biography of Zilpha Keatley Snyder.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zilpha Keatley Snyder
      </h2>
      
      <p class="authorDescription body article">Zilpha Keatley Snyder (b. 1927) is a three-time Newbery Honor&ndash;winning author of adventure and fantasy novels for children. Her smart, honest, and accessible narrative style has made her books beloved by generations. When not writing, she enjoys reading and traveling. Snyder lives in Mill Valley, California.&#160; &#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42a534e8